import axios from './productInstance'
import { notifyOnboardingStatusChanged } from '@/features/onboarding/events'

const saveViewProfile = async (data: any) => {
  try {
    const hasId = !!data?.id
    const res = hasId
      ? await axios.put(`/view-profiles/`, data)
      : await axios.post(`/view-profiles/`, data)
    notifyOnboardingStatusChanged()
    return res
  } catch (error) {
    console.error('Error saving view profile data:', error)
    return null
  }
}

export default saveViewProfile
